module.exports = __webpack_public_path__ + "media/Video 135-136-137.78d801d7.mp4";